import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Route, Switch } from "react-router-dom";

import {
  readUserAsync,
  updateUserAsync,
  updateUserImageAsync,
} from "settings/actions/users";
import UserImageEditor from "settings/components/UserImageEditor";
import UserForm from "settings/components/UserForm";

import styles from "./User.css";

class User extends React.Component {
  constructor(props) {
    super(props);

    this.username = props.match.params.username || "me";
  }

  componentDidMount() {
    this.props.readUserAsync(this.username);
  }

  render() {
    const myAccount = this.username === "me";
    const account = myAccount
      ? "Your account"
      : `${this.props.profileUser.display_name}'s account`;

    return (
      <div
        className={classNames(styles.root, { [styles.myaccount]: myAccount })}
      >
        <Switch>
          <Route
            exact
            path="/settings/user/me/image"
            component={UserImageEditor}
          />
          <Route
            exact
            path="/settings/user/:username/image"
            component={UserImageEditor}
          />
          <Route
            render={props => (
              <UserForm
                fields={[
                  { slug: "first_name", name: "First name", required: true },
                  { slug: "last_name", name: "Last name", required: true },
                  { slug: "display_name", name: "Byline" },
                  { slug: "job_title", name: "Job title" },
                  { slug: "bio_line", name: "Bio" },
                ]}
                titleText={account}
                successText={`${account} updated`}
                user={this.props.profileUser}
                save={user => this.props.updateUserAsync(this.username, user)}
                saveImage={this.props.updateUserImageAsync}
                showCancel={!myAccount}
                showPermissions={!myAccount}
                {...props}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.user,
  profileUser: state.settings.users.profile,
});

const mapDispatchToProps = {
  readUserAsync,
  updateUserAsync,
  updateUserImageAsync,
};

User.propTypes = {
  currentUser: PropTypes.object,
  profileUser: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(User);
